interface ActivatableProject {
    activated_at?: string | null;
    mode?: string | null;
}

/**
 * Some legacy rows can be active while activated_at is still null.
 * Treat active mode as activated to keep UI/state consistent.
 */
export function isProjectActivated(project: ActivatableProject | null | undefined): boolean {
    if (!project) return false;
    return Boolean(project.activated_at) || project.mode === 'active';
}
